import { useEffect, useState } from 'react';

const useVersionCheck = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [newVersion, setNewVersion] = useState(null);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        // Fetch version.json with cache busting
        const response = await fetch(`/version.json?t=${Date.now()}`);
        const remoteVersion = await response.json();

        // Get stored version from localStorage
        const storedVersion = localStorage.getItem('app_version');
        const storedBuildTime = localStorage.getItem('app_build_time');

        // First time visit or version changed
        if (!storedVersion || !storedBuildTime) {
          // Store current version
          localStorage.setItem('app_version', remoteVersion.version);
          localStorage.setItem('app_build_time', remoteVersion.buildTime);
        } else if (
          storedVersion !== remoteVersion.version ||
          storedBuildTime !== remoteVersion.buildTime
        ) {
          // New version detected
          console.log('🎉 New version available!', {
            old: { version: storedVersion, buildTime: storedBuildTime },
            new: remoteVersion
          });
          setNewVersion(remoteVersion);
          setUpdateAvailable(true);
        }
      } catch (error) {
        console.error('Version check failed:', error);
      }
    };

    // Check immediately on mount
    checkVersion();

    // Check every 5 minutes
    const interval = setInterval(checkVersion, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  const applyUpdate = () => {
    if (newVersion) {
      // Update localStorage
      localStorage.setItem('app_version', newVersion.version);
      localStorage.setItem('app_build_time', newVersion.buildTime);
      
      // Clear all caches and reload
      if ('caches' in window) {
        caches.keys().then((names) => {
          names.forEach((name) => caches.delete(name));
        });
      }
      
      // Hard reload
      window.location.reload(true);
    }
  };

  return { updateAvailable, newVersion, applyUpdate };
};

export default useVersionCheck;
